import React, { useEffect, useState } from 'react';
import { useToastrVanila } from '../../hooks/util/useToastrVanila';
import IEmployee from '../../interfaces/IEmployee';
import IFormError from '../../interfaces/IFormError';
import { useEmployeeService } from '../../hooks/services/useEmployeeService';
import debounce from 'lodash.debounce';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';

interface IProps {
  setEmployee: (employee: IEmployee | null) => void;
  employee: IEmployee | null;
}

const FollowupSearchEmployee = (props: IProps) => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly IEmployee[]>([]);
  const loadingInput = open;

  const request = useEmployeeService();

  const toastr = useToastrVanila();

  const [errors, setErrors] = useState<IFormError | null>();

  useEffect(() => {
    let active = true;

    if (!loadingInput) {
      return undefined;
    }

    (async () => {
      if (active) {
        await loadEmployees(' - ');
      }
    })();

    return () => {
      active = false;
    };
  }, [loadingInput]);

  useEffect(() => {
    setErrors(null);
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const loadEmployees = debounce(async (filter = ' ') => {
    setLoading(true);
    await request
      .listForMedicalCertificateSearch(filter)
      .then(employees => {
        setOptions(employees);
        setLoading(false);
      })
      .catch(error => {
        toastr.error(`Erro ao carregar os dados: ${error.message}`);
        setLoading(false);
      });
  }, 500);

  return (
    <Autocomplete
      open={open}
      value={props.employee}
      onChange={(e: any, newValue) => {
        const castedEmployee = { ...newValue } as IEmployee;
        props.setEmployee({ ...castedEmployee });
      }}
      onOpen={() => {
        setOpen(true);
        props.setEmployee(null);
      }}
      onClose={() => {
        setOpen(false);
      }}
      isOptionEqualToValue={(option, value) => {
        return option?.name === value?.name;
      }}
      getOptionLabel={option => (option?.cpf && option.code ? `${option.code} - ${option.cpf} - ${option.name}` : '')}
      options={options}
      loading={loading}
      renderInput={params => (
        <TextField
          {...params}
          label="Pesquisar colaborador por matrícula, nome ou CPF"
          error={Boolean(errors?.cpf)}
          helperText={errors?.cpf}
          size="small"
          onChange={e => {
            loadEmployees(e.target.value);
          }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default FollowupSearchEmployee;
